import { useQuery } from '@tanstack/react-query'
import { api, AuditLogsQuery, AuditLogsResponse } from '@/lib/api'

export function useAuditLogs(params?: AuditLogsQuery) {
  const { data, isLoading, error, refetch } = useQuery<AuditLogsResponse>({
    queryKey: ['auditLogs', params],
    queryFn: () => api.getAuditLogs(params),
    retry: 1,
    staleTime: 10000,
  })

  return {
    logs: data?.logs || [],
    total: data?.total || 0,
    isLoading,
    error,
    refetch,
  }
}
